export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=40b4179bda6408c9e975b140d9ede896edf5a4db6c&name=addToFolderEventAction!'